import React, { useState, useEffect, useRef } from 'react';
import {
  Button,
  Column,
  Grid,
  DataTable,
  Modal,
  Pagination,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  TableToolbar,
  TableToolbarContent,
  TableToolbarSearch,
  TableSelectAll,
  TableSelectRow,
  TableBatchAction,
  TableBatchActions,
  TextInput,
  TextArea,
  Select,
  SelectItem,
  RadioButton,
  RadioButtonGroup,
  Row,
  Theme,
} from '@carbon/react';
import { AddAlt, TrashCan } from '@carbon/icons-react';

import { deleteDoc, getDocumentDAO, getResoucesForViews, elegirDoc } from '../../services/services';
import SessionController from '../../components/FrontSessionController/SessionController';
import CommodityHeader from '../../components/Header';
import MessageModal from '../../components/MessageModal/MessageModal';
import { useNavigate } from "react-router-dom";

const headers = [
  {
    key: 'formtype',
    header: 'Form Type',
  },
  {
    key: 'status',
    header: 'Status',
  },
  {
    key: 'suppliernmb',
    header: 'Supplier',
  },
  {
    key: 'nextapprover',
    header: 'Next Approver',
  },
  {
    key: 'ctrycode',
    header: 'Country',
  },
  {
    key: 'compcode',
    header: 'Company',
  },
  {
    key: 'invonumb',
    header: 'Internal Reference',
  },
  {
    key: 'deleted',
    header: 'Deleted',
  },
  {
    key: 'justification',
    header: 'Justification',
  },
  {
    key: 'user',
    header: 'User',
  },
  {
    key: 'date',
    header: 'Date',
  },
];


const DocumentsDeletion = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [rows, setRows] = useState([]);

  const [docModal, setGetDocModal] = useState(false);
  const [justifModal, setJustifModal] = useState(false);
  const [justifications, setJustifications] = useState([]);
  const [justifChosen, setJustifChosen] = useState([]);
  const [selectedrows, setSelectedRows] = useState([]);
  const [inputGetDoc, setInputGetDoc] = useState();
  const [searchByType, setSearchByType] = useState('invonumb');
  const [messageSessionLost, setMessageSessionLost] = useState('');
  const [messageModal, setMessageModal] = useState('');
  const [showJustificationInput, setShowJustificationInput] = useState('');
  const messageResponse = useRef([]); 
  const processingRequest = useRef(false);
  const requestAction = useRef('');

  const changePaginationState = (pageInfo) => {
    if (page !== pageInfo.page) {
      setPage(pageInfo.page)
    }
    if (pageSize !== pageInfo.pageSize) {
      setPageSize(pageInfo.pageSize)
    }
  };

  function debounce(func, delay) {
    let timeout;
    return function(...args) {  // Collect all arguments passed to the debounced function
      clearTimeout(timeout);    // Clear any existing timeout
      timeout = setTimeout(() => {
        func.apply(this, args); // Execute the original function with the correct context and arguments
      }, delay);
    };
  }

  const isRequestActive = (enable) => {
    if(enable){
      if(processingRequest.current){
        openMessageModal('The request is processing');
        return true;
      }
      document.body.className = 'waiting';
      processingRequest.current = enable;      
      return false;
    }else{
      processingRequest.current = enable;
      document.body.className = '';
    }
    return false;
  }

  const openMessageModal = (response) => {    
    let newMessageResponse = [messageResponse.current,<br/>,<br/>,response];    
    messageResponse.current = newMessageResponse;
    setMessageModal(true);
  }

  const closeMessageModal = () => {
    setMessageModal(false);    
    messageResponse.current = [];
  }

  const getDocumentToDelete = async (request) => {
    if(isRequestActive(true)){
      return;
    } 
    await getDocumentDAO(request)
    .then(response => {
      if(response.status === 200){
        response.json()
          .then(response => {
            parserResponseGetDoc(response);
            openMessageModal("The document: " + response.ctrycode + "-" + response.compcode + "-" + response.invonumb +
              " is now visible at the top of the table. ")
          })
      } else if(response.status === 410)   {
        response.text()
          .then(res => {
            setMessageSessionLost(res)                             
          })
      }else{
        response.text()
          .then(res => {
            openMessageModal(res)                             
          })
      }
    });
    isRequestActive(false);
  }
      
  const requestGetDocumetsDeletedIsActive = useRef(false);
  const getDocumentsDeleted = async (request) =>{
    if(requestGetDocumetsDeletedIsActive.current) {return}
    requestGetDocumetsDeletedIsActive.current = true;
    document.body.className = 'waiting';
    await getResoucesForViews(request)
    .then(response => {
      if(response.status === 200){
        response.json()
          .then(response => {
            parserIdInResponse(response.lDocsDao);
            setJustifications(response.justifList)
          })
      } else if(response.status === 410)   {
        response.text()
          .then(res => {
            setMessageSessionLost(res)                             
          })
      } else{
        response.text()
          .then(res => {
            openMessageModal(res)                             
          })
      }
      requestGetDocumetsDeletedIsActive.current = false;
    });
    document.body.className = '';
  }



  const processActionDoc = async (request) => {
    if(isRequestActive(true)){
      return;
    } 
    await deleteDoc(request)
    .then(response => {
      if(response.status === 200){
        response.json()
          .then(response => {
            openMessageModal(`The documents has been ${request.accion} successfully`)
            parserIdInResponse(response);
          })
      }else if(response.status === 410)   {
        response.text()
          .then(res => {
            setMessageSessionLost(res)                             
          })
      }  else{
        response.text()
          .then(res => {
            openMessageModal(res)                             
          })
      }
    });
    isRequestActive(false);
  }
   

  const parserResponseGetDoc = (res) => {
    setRows([
      {
        id: "" + res.idDoc,
        formtype: "" + res.flow,
        status: "" + res.docStatus,
        suppliernmb: "" + res.supplierNumber,
        nextapprover: "" + res.nextApproverName,
        ctrycode: "" + res.ctrycode,
        compcode: "" + res.compcode,
        invonumb: "" + res.invonumb,
        deleted: "" + (res.deleted === "S" ? ('Yes') : ("No")),
        justification: "",
        user: "", //user logged
        date: ""
      },
      ...rows // Put old items at the end
    ]);
  };

  

  const parserIdInResponse = (response) => {
    const resParsed = response.map((res, i) => {
      const parsed = {};
      parsed["id"] = "" + res.idDoc;
      parsed["formtype"] = res.flow;
      parsed["status"] = res.docStatus;
      parsed["suppliernmb"] = res.supplierNumber;
      parsed["nextapprover"] = res.nextApproverName;
      parsed["ctrycode"] = res.ctrycode;
      parsed["compcode"] = res.compcode;
      parsed["invonumb"] = res.invonumb;
      parsed["deleted"] = (res.deleted === "S" ? ('Yes') : ("No"));
      parsed["justification"] = res.justification;
      parsed["user"] = res.whoDeleted;
      parsed["date"] = res.whenDeleted;
      return parsed;
    });
    setRows(resParsed);
    
  };

  const processIdsToDelete = (selectedRows) => {
    for (let index = 0; index < selectedRows.length; ++index) {
      if (selectedRows[index].cells[7].value === "Yes") {
        openMessageModal("The document selected " + selectedRows[index].cells[6].value + " is already deleted. Try with another document.")
        return;
      }
    }
    openJustifModal();
    requestAction.current = 'delete';
    setSelectedRows(selectedRows);    
  };

  const processIdsToUndelete = (selectedRows) => {
    let ids = "";
    for (let index = 0; index < selectedRows.length; ++index) {
      if (selectedRows[index].cells[7].value === "No") {
        openMessageModal("The document selected " + selectedRows[index].cells[6].value + " is not deleted. \nYou can't "+
        "delete a document which it is not deleted. Try with another document.")
        return;
      }            
    }
    openJustifModal();
    requestAction.current = 'undelete';
    setSelectedRows(selectedRows);  
  };

  const goHomeScreen = () => {
    navigate('/home')
  };

  const openJustifModal = () => {
    setJustifModal(true);
  };

  const closeJustifModal = () => {
    setJustifModal(false);
  };

  const closeDocModal = () => {
    setGetDocModal(false);
  };

  const openDocModal = () => {
    setGetDocModal(true);
  };

  const processGetDoc = (type) => {
    if (type === "invonumb") {
      setSearchByType("invonumb");
    } else if (type === "invoice") {
      setSearchByType("nrofac");
    }
  };

  const processInputForGetDoc = (e) => {
    const type = e.target.id;
    if (type.includes("input-getDoc")) {
      setInputGetDoc(e.target.value);
    }
  };

  const processJustificationSelection = (justification) => {
    setShowJustificationInput(justification === 'Other')      
    setJustifChosen(justification)
  }

  const updateJustification = (otherJustification) => {
    setJustifChosen(otherJustification);
  }

  const debouncedUpdateJustification = debounce(updateJustification, 300);

  const submitSearchDoc = () => {    
    let request = {};
    request.tipoClave = searchByType;
    request.clave = inputGetDoc;
    getDocumentToDelete(request);
    closeDocModal();    
  };  

  const submitJustif = () => {
    closeJustifModal();
    let ids = "";
    for (let index = 0; index < selectedrows.length; ++index) {      
      ids = ids + selectedrows[index].id + ";";
    }
    ids = ids.substring(0, ids.length - 1);        
    
    let request = {};
    request.accion = requestAction.current;
    request.opcion = justifChosen;
    request.ids = ids;    
    
    processActionDoc(request);
  };

  const goToDocumentDeletedView = (idDoc) => {      
    getDocumentForDeletedView(idDoc);     
  };

  const getDocumentForDeletedView = async (idDoc) => { 
    if(isRequestActive(true)){
      return;
    } 
    await elegirDoc(idDoc)
      .then(response => {
        if(response.status === 200){          
          if(response.status === 200) {
            console.log(200)           
          }
          navigate('/minimal-document-view');
        }else if(response.status === 410)   {
          response.text()
            .then(res => {
              setMessageSessionLost(res)                             
            })
        }else{
          response.text()
            .then(res => {
              openMessageModal(res)                             
            })
        } 
      })                   
    isRequestActive(false);
  };

  useEffect(() => {
    let request = {};
    request.viewName = 'deletedList';
    getDocumentsDeleted(request);    
  }, [0])

  return (
    <>
      <h2 className="table-title">Documents Deletion</h2>
      <Grid>
        <Modal
          className="getDocumentByType-modal"
          focusTrap={false}
          hasscrollingcontent="false"
          iconDescription="Close the modal"
          aria-label="Find Approver modal"
          modalAriaLabel="Find Approver modal"
          onBlur={function noRefCheck() { }}
          onClick={function noRefCheck() { }}
          onFocus={function noRefCheck() { }}
          onKeyDown={function noRefCheck() { }}
          onRequestClose={() => closeDocModal()}
          onRequestSubmit={() => submitSearchDoc()}
          onSecondarySubmit={() => closeDocModal()}
          open={docModal}
          passiveModal={false}
          primaryButtonDisabled={false}
          primaryButtonText="Submit"
          secondaryButtonText="Cancel"
          selectorPrimaryFocus="[data-modal-primary-focus]"
          modalLabel={<p><strong>Search document to delete</strong></p>}
        >
          <Grid className="column-getDoc">
            <Column lg={16}>
            <p><strong>Search By:</strong></p>
              <Row className={"text-test"}>
                <RadioButtonGroup  name="select-radio-button" defaultSelected="radio-1">
                  <RadioButton labelText="Internal Reference" onClick={() => processGetDoc("invonumb")} value="radio-1" id="radio-1" />
                  <RadioButton labelText="Invoice Number" onClick={() => processGetDoc("invoice")} value="radio-2" id="radio-2" />
                </RadioButtonGroup>
                <TextInput className="" light onChange={(e) => processInputForGetDoc(e)} id="text-input-getDoc" type="text" placeholder="" size="md" />

              </Row>
            </Column>
          </Grid>

        </Modal>
      </Grid>
      <Grid>
        <Modal
          className="justificationModal"
          focusTrap={false}
          hasscrollingcontent="false"
          iconDescription="Close the modal"
          aria-label="Justification modal"
          modalAriaLabel="Justification modal"
          onBlur={function noRefCheck() { }}
          onClick={function noRefCheck() { }}
          onFocus={function noRefCheck() { }}
          onKeyDown={function noRefCheck() { }}
          onRequestClose={() => closeJustifModal()}
          onRequestSubmit={() => submitJustif()}
          onSecondarySubmit={() => closeJustifModal()}
          open={justifModal}
          passiveModal={false}
          primaryButtonDisabled={false}
          secondaryButtonDisabled={true}
          primaryButtonText="Submit"
          selectorPrimaryFocus="[data-modal-primary-focus]"
          modalLabel={<p><strong>Please select a justification or enter other</strong></p>}
        >
          <Grid className="column-getDoc">
            <Column lg={16}>
              <Row className={"text-test"}>
                <Select className="style-select-delegation"
                  labelText="Justification:"                  
                  id="selectJustif"
                  onChange={(e) => processJustificationSelection(e.target.value)}
                >
                  {
                    justifications.map((just) => (
                      <>
                        <SelectItem key={just.ID} text={just.JUSTIFICACION} value={just.JUSTIFICACION}></SelectItem>
                      </>
                    ))
                  }
                  {justifications.length > 0 &&
                    <SelectItem key={0} text={"Other"} value={"Other"}></SelectItem>
                  }

                </Select>
              </Row>
              <Row>
                {showJustificationInput &&
                  <TextArea                
                    counterMode="character"
                    labelText="Reason"
                    enableCounter="true"
                    maxCount={300}
                    onChange={(e) => debouncedUpdateJustification(e.target.value)}                
                    rows={4} id="text-area-1" />
                }

              </Row>
            </Column>
          </Grid>

        </Modal>
      </Grid>
      <Grid>
        <Theme theme="g90">
            <CommodityHeader />
        </Theme>
        
        <Column lg={16} >
        <Button className='style-bttbackID' size="lg" onClick={goHomeScreen}>Back to Home</Button>
        <Button className="style-bttGetDocument" onClick={() => openDocModal()} size="lg">Get Document To Delete</Button>
          <DataTable
            isSortable={true}
            rows={rows}
            headers={headers}
            render={({
              rows,
              headers,
              getHeaderProps,
              getRowProps,
              getTableProps,
              getSelectionProps,
              onInputChange,
              getBatchActionProps,
              selectedRows
            }) => (

              <TableContainer>
                
                

                <TableToolbar>
                  <TableToolbarContent>
                    <TableToolbarSearch persistent size="sm" onChange={onInputChange} />
                    {/* pass in `onInputChange` change here to make filtering work */}
                  </TableToolbarContent>

                  <TableBatchActions {...getBatchActionProps()}>
                    <TableBatchAction renderIcon={AddAlt} iconDescription="Undelete"
                      onClick={() => { processIdsToUndelete(selectedRows); getBatchActionProps().onCancel(); }}> Undelete
                    </TableBatchAction>
                    <TableBatchAction renderIcon={TrashCan} iconDescription="Delete"
                      onClick={() => { processIdsToDelete(selectedRows); getBatchActionProps().onCancel(); }}> Delete
                    </TableBatchAction>
                  </TableBatchActions>
                </TableToolbar>


                <Table {...getTableProps()} useZebraStyles>
                  <TableHead>
                    <TableRow>
                      <TableSelectAll {...getSelectionProps()} />

                      {headers.map(header => (
                        <TableHeader {...getHeaderProps({ header })}>
                          {header.header}
                        </TableHeader>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.slice((page - 1) * pageSize).slice(0, pageSize).map((row) => (

                      <TableRow {...getRowProps({ row })}>
                        <TableSelectRow  {...getSelectionProps({ row })} />
                        {row.cells.map(cell => (

                          <TableCell  onClick={() => goToDocumentDeletedView(row.id)} key={cell.id}>{cell.value}</TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <Pagination
                  onChange={changePaginationState}

                  backwardText="Previous page"
                  forwardText="Next page"
                  itemsPerPageText="Items per page:"
                  page={page}
                  pageNumberText="Page Number"
                  pageSize={pageSize}
                  pageSizes={[
                    10,
                    25,
                    50,
                    100,
                  ]}
                  totalItems={rows.length}
                />
              </TableContainer>
            )}
          />
        </Column>
        <SessionController messageLostSessionCallback={messageSessionLost} />
        <MessageModal messageCallback={messageResponse.current} messageModalCallback={messageModal} closeMessageModalCallback={closeMessageModal}/>
      </Grid>

    </>
  );
};

export default DocumentsDeletion;